<template>
  <div v-wechat-title="$route.meta.title='直播列表'">
  <van-pull-refresh style="min-height: 100vh;" v-model="isLoading" @refresh="onRefresh">
    <van-list
      v-model="loading"
      :finished="finished"
      :offset="1"
      finished-text="没有更多了"
      @load="onLoad"
    >
      
            <div style="padding: .5rem;height:12rem" v-for="(item,index) in list" :key="item.id"   >
                <div class="activity" :style="{backgroundImage:'url('+item.img+')'}">
                <div @click="todetail(item.id)" v-if="item.status==0" class="news_r" >
                   <img  class="trailer" src="../../assets/images/trailer.png">
                    <img v-if="item.subscribe==0" @click.stop="subscribe(1,index,item.id)" class="subscribe" src="../../assets/images/subscribe.png">
                    <img v-if="item.subscribe==1" @click.stop="subscribe(0,index,item.id)" class="subscribe" src="../../assets/images/unsubscribe.png">
                    <p class="content">
                      <label>{{item.title}}</label>
                      <div style="font-size: .9rem;margin-bottom: .2rem">
                        <img style="width:1rem"  src="../../assets/images/livedate.png">
                        直播时间
                      </div>
                      <span>{{item.start_time}}-{{item.end_time}}</span><br/>
                      
                    </p>
                </div>
                 <div @click="tolive(item.liveurl)" v-else-if="item.status==2" class="news_r" >
                    <p >
                        <label>{{item.title}}</label>
                        <img   class="playback" src="../../assets/images/playback.png">
                   
                    </p>
                </div>
                 <div @click="tolive(item.liveurl)" v-else class="news_r" >
                   <p >
                        <label>{{item.title}}</label>
                        <img   class="playback" src="../../assets/images/living.png">
                   
                    </p>
                </div>
              </div>    
      </div>
     </van-list>
</van-pull-refresh>
      <van-popup class="van-popup" :close-on-click-overlay="false" v-model="popupShow">
            <div v-if="isSubscribe" :class="popupmsg" style="margin-top: 2rem">
               <van-image
                  v-if="subscribeType==1"
                  width="5rem"
                  :src="require('../../assets/images/success.png')"
                />
                <label style="font-weight:600;font-size:1rem;display:block;margin: 1rem;">{{message}}</label>
                 <van-button @click="close"   class="close" >我知道了</van-button> 
              </div>
             <div class="is-subscribe" v-else>
                <div class="text">
                   您还不是莱美官方服务号的粉丝，无法收到订阅提醒。请扫描下方二维码，或者微信搜索 <span>"莱美爱好者"</span>，关注后获取接收订阅通知~
                </div>
                <van-image
                  width="10rem"
                  :src="require('../../assets/images/qcode.jpg')"
                />
                 <van-button @click="close"   class="close1" >我知道了</van-button> 
             </div> 
           </van-popup>
</div>
</template>
<script>
import { getLive,subscribe } from '@/api/api.js'
export default {
    components: {
       
    },
    data(){
        return{
        
            list:[],
            page:1,//页码,默认为1
            pageNum:10,//每页数量
            page_count:1,//总页数,初始为1 
            isLoading: false ,//下拉刷新
            loading: false,
            finished: false,
            button:true,
            popupShow:false,
            subscribeType:1,
            message:'',
            popupmsg:'popup-msg',
            isSubscribe:0 
        }
    },
    beforeMount() {
        
    },
    mounted() {
        
    },
    methods: {
        //下拉刷新
           onRefresh() {
              this.page = 1;
              this.list = [];
              this.onLoad();
              setTimeout(() => {
                this.$toast('刷新成功');
                this.isLoading = false;
                this.finished = false;
              }, 500);
            },
            //下拉加载10
             onLoad() {
              // 异步更新数据
                let parame = {'page':this.page,'pageNum':this.pageNum};
                getLive(parame).then((res)=>{
                    if(res.code==200){
                        if (res.result.list.length > 0) {//没有数据
                            if(this.list.length==0){
                                    this.list = res.result.list;

                            }else{
                                this.list = this.list.concat(res.result.list)
                                
                            }
                            this.page_count = res.result.page_count;
                            this.page++;
                             // 加载状态结束
                            this.loading = false;
                           
                        }else{
                             // 数据全部加载完成
                            this.finished = true;
                            this.loading = false;
                        }  
                    } 
                   //Toast('提示内容')
                  //console.log(this.list);  
                }),(err)=>{
                    console.log(err);
                }
                          
              
         },
      //视频列表
      tolive(url){
       window.location.href=url;
      },
      //订阅和取消订阅
      subscribe(type,index,id){
        if(this.button){
           this.button = false
           let parame = {'status':type,'id':id};
                subscribe(parame).then((res)=>{
                    if(res.code==200){
                        if(res.result['type']=='subscribe'){
                            this.list[index].subscribe = 1;
                            this.subscribeType = 1
                            this.popupmsg = 'popup-msg'
                        }else{
                           this.list[index].subscribe = 0;
                            this.subscribeType = 0
                            this.popupmsg = 'popup-msg1'
                        }
                        this.message = res.message
                        this.isSubscribe = res.result['isSubscribe']
                        this.button = true
                        this.popupShow = true
                    } 
                   //Toast('提示内容')
                  //console.log(this.list);  
                }),(err)=>{
                    console.log(err);
                     this.button = true
                }
        }
      } ,
      //跳转到详情
      todetail(id){
         this.$router.push({name:'liveDetial',query: {id:id}})  
      },
       close(){
             this.popupShow = false
        },
       
    
    }
}
</script>
<style  scoped>
  .close{
    margin:auto;
    color:#000;
    width: 70%;
    background-color:#ffc425;
    border: none;
    margin-bottom: 1.5rem;
    font-weight:600;
  }
    .van-popup{
    border-radius: .5rem;
  }
  .is-subscribe{
     width:18rem;
     height:24rem;
     top:45%;
     color:#000;

  }
  .is-subscribe>.text{
    padding: 1rem;
    text-align: left;
    padding: 1rem;
    text-align: left;
    letter-spacing: .01rem;
    font-size: 0.9rem;

  }
  .popup-msg{
    width:16rem;
    height:13rem;
    top:45%;
    color:#000;
  }
  .popup-msg1{
    width: 16rem;
    height: 7rem;
    top:45%;
    color:#000;
  }
.demo-lazyload {
      box-sizing: border-box;
      height: 200px;
      margin: 10px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
.activity{
     height: 100%;
    width: 100%;
    background-color: white;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position:relative;
    margin-bottom: .6rem;
}
.news_r{
    position: absolute;
   /* bottom: 3rem;*/
    width: 100%;
    height:100%;
    color: white;
    font-size:1rem;
    font-weight: 600;
    background-color: rgba(50, 50, 51,0.4);
}
.news_r p{
   margin-top: 3rem
}
.news_r>p>label{
  
    display: block;
    letter-spacing:.1rem;
}
.content>span{
  font-size: .9rem
}
.success{
  position: absolute;
    left: 0;
}
.activity_start{
  position: absolute;
    right: 0;
}
.subscribe{
    width: 4rem;
    float: right;
    margin: .5rem;
}
.trailer{
   width: 2.5rem;
    float: left;
    margin: 1rem;
}
.playback{
   width: 4rem;
   margin: 2.5rem;
}
.close1{
    width:9rem;
    margin:auto;
    color:#000;
    background-color:#ffc425;
    border: none;
    margin-bottom: 1.5rem;
    font-weight:600;
}

</style>
